// 메신저 스레드 답글 요약줄(«답장 N개») 바로 오른쪽에 «안읽은 메세지 +n» 배지와 파란 점을 붙인다.
// 설계: `patch_req_req-20261019-111255-69bb64_p2`(요청 req-20261019-111255-69bb64 «스레드 "안읽은 메세지" 건수 표시»).
// 건수는 게이트웨이가 센다 — 조회 `GET /api/mm/thread-unread` · 읽음 `POST /api/mm/thread-read`(P1, routers/mm_read.py).
//
// 🔴 MM DOM 은 MM 소유다 — 아래 셀렉터 상수는 MM 공개 소스 관례에서 온 추정값이다(레포·DEV 번들 실측 아님).
//    footer·답장 버튼을 못 찾으면 조용히 무동작(지금 화면 그대로). MM 노드는 옮기거나 지우지 않는다 —
//    우리 노드를 «추가» 만 하고, MM 이 다시 그리면 다음 점검에서 다시 붙인다.
// 🔴 MM 파란 점은 «지켜보는 중» 스레드에서만 반응한다 → «지켜보기와 무관하게 점 = 건수» 를 MM 점으로는 못 맞춘다.
//    그래서 우리 건수를 가진 footer(MARK_ATTR)에서만 MM 점을 CSS 로 숨기고, 같은 캐시 값으로 우리 점을 그린다.
// 🔴 style 은 «첫 배지를 그릴 때» 넣는다 — footer 가 없는 문서(기존 jsdom 시험 문서 포함)에는 넣지 않는다.
//    @media 는 `(max-width:768px)` 만 쓴다 — 주입 style 전수 시험(r6_32de5811df·r6_8fbe555233)의 미디어
//    해석기는 width 조건이 아니면 던진다(`(pointer:coarse)` 금지).
// 🔴 API 가 없거나(404) 꺼져 있으면(enabled:false) 이 문서 동안 무동작 — 붙인 것을 전부 걷어 MM 원래 모습으로.
//    서버가 한 번이라도 enabled 로 답하기 전에는 아무것도 그리지 않고 읽음도 보내지 않는다.
// 🔴 값은 textContent 로만 넣는다(innerHTML 금지). 예외는 전부 삼킨다.
// 🔴 열린 스레드 판정(10-19 사람 재수정 — «열면 0건·새로고침 후 유지·열어 둔 동안 +1 없음»):
//    MM 7+ 는 RHS 의 루트 글도 답글과 같은 `rhsPost_<id>` 다(`rhsRootPost_` 는 옛 MM). 그래서 `rhsRootPost_`
//    만 찾으면 MM 11 에서는 스레드를 열어도 «열림» 이 안 잡혀 0건·읽음 요청이 둘 다 안 나간다.
//    → RHS 에 그려진 `rhsPost_<id>` 중 «루트로 알려진» id(가운데 footer 의 루트 ∪ 캐시 — 답글엔 footer 가 없다)를
//    열린 스레드로 본다. 긴 스레드는 루트 글이 가상 목록 밖으로 빠질 수 있어서 ① 방금 누른 «답장 N개»·배지·
//    답장 아이콘의 루트(INTENT_WAIT_MS 동안) ② RHS 가 닫히거나 다른 루트가 보이기 전까지 직전 판정을 이어 쓴다.
//    닫히는 순간 못 보낸 읽음은 한 번 보내고, 읽음이 끝나기 전에 받은 «읽음 전» 건수는 그리지 않는다(syncReads·applyCounts).
//    «내가 쓴 답글은 안 센다» 는 서버 몫이다(P1 `p.userid <> 나`).
export const FOOTER_SEL = '.ThreadFooter';
export const REPLY_SEL = '.ReplyButton';
export const FOLLOW_SEL = '.FollowButton';
export const INDICATOR_SEL = '.indicator';
export const POST_SEL = '[data-testid="postView"]';
export const RHS_ROOT_SEL = '[id^="rhsRootPost_"]';   // 옛 MM 의 RHS 루트 글
export const RHS_POST_PREFIX = 'rhsPost_';            // MM 7+ 는 RHS 루트 글도 이 접두다
export const COMMENT_ICON_PREFIX = 'CENTER_commentIcon_';   // 가운데 글 호버 메뉴의 답장 아이콘
export const REPLY_BOX_SEL = '#reply_textbox';        // 스레드 입력창(utils/mmSticker·mmExcelPaste 와 같은 값) — RHS 스레드가 열려 있다

export const BADGE_CLASS = 'gw-thread-unread';
export const DOT_CLASS = 'gw-thread-dot';
export const WRAP_CLASS = 'gw-indicator';      // MM indicator 가 없을 때 우리가 만드는 점 자리
export const MARK_ATTR = 'data-gw-tu';
export const STYLE_ID = 'gw-mm-thread-unread-css';

export const SYNC_THROTTLE_MS = 300;
export const REFRESH_MS = 20000;        // 다른 기기·탭에서 읽은 것 반영
export const FETCH_MIN_GAP_MS = 1000;
export const FAIL_BACKOFF_MS = 60000;   // 5xx·네트워크 오류
export const READ_DEBOUNCE_MS = 800;
export const READ_MIN_GAP_MS = 2000;    // 루트당 읽음 요청 최소 간격
export const SCROLL_WAIT_MS = 3000;
export const SCROLL_STEP_MS = 100;
export const MAX_ROOTS = 60;            // = 서버 MAX_ROOTS
export const INTENT_WAIT_MS = 3000;     // 답장 버튼·배지를 누른 뒤 MM 이 그 스레드를 RHS 에 그릴 때까지

const ROOT_POST_RE = /^post_([a-z0-9]{26})$/;
const RHS_ROOT_RE = /^rhsRootPost_([a-z0-9]{26})$/;
const RHS_POST_RE = /^rhsPost_([a-z0-9]{26})$/;
const THREAD_PATH_RE = /\/threads\/([a-z0-9]{26})(?:[/?#]|$)/;
const MM_ID_RE = /^[a-z0-9]{26}$/;
const REPLY_TEXT_RE = /답장|repl/i;

// 답장 N개와 배지 사이 간격은 배지 margin 6px 하나로 고정한다(ReplyButton 의 끝 여백을 0 으로).
// 지켜보기·시간(호버 때만 보이는 MM 요소)은 DOM 에서 배지 오른쪽이라 나타나도 배지 위치는 그대로다 —
// 자리가 모자라면 그것들이 다음 줄로 내려가고 배지는 nowrap 이라 잘리지 않는다.
export const THREAD_UNREAD_CSS = [
  '.' + BADGE_CLASS + '{display:inline-flex;align-items:center;flex:0 0 auto;white-space:nowrap;',
  'margin:0 8px 0 6px;padding:2px 4px;border:0;background:none;font:inherit;font-size:12px;cursor:pointer}',
  '.' + BADGE_CLASS + '--has{color:var(--button-bg,#1c58d9);font-weight:600}',
  '.' + BADGE_CLASS + '--zero{color:rgba(var(--center-channel-color-rgb,63,67,80),.64)}',
  FOOTER_SEL + '[' + MARK_ATTR + ']{flex-wrap:wrap;row-gap:4px}',
  FOOTER_SEL + '[' + MARK_ATTR + '] ' + REPLY_SEL + '{margin-inline-end:0}',
  FOOTER_SEL + '[' + MARK_ATTR + '] ' + INDICATOR_SEL + ' > :not(.' + DOT_CLASS + '){display:none !important}',
  '.' + DOT_CLASS + '{display:inline-block;width:8px;height:8px;border-radius:50%;background:var(--button-bg,#1c58d9)}',
  '@media (max-width:768px){.' + BADGE_CLASS + '{min-height:32px;padding:6px;margin-inline-end:12px;',
  'touch-action:manipulation}}',
].join('');

// n ≤ 0 → «0건», 1~99 → «+n», 99 초과 → «+99».
export function formatUnreadLabel(n) {
  const v = Math.floor(Number(n));
  if (!Number.isFinite(v) || v <= 0) return '안읽은 메세지 0건';
  if (v > 99) return '안읽은 메세지 +99';
  return '안읽은 메세지 +' + v;
}

// style#gw-mm-thread-unread-css 를 head 에 '1개만' 유지한다(멱등 — mmProfileExtra 와 같은 형태).
function applyCss(doc) {
  if (!doc || !doc.head) return;
  const found = doc.getElementById(STYLE_ID);
  if (found) {
    if (found.textContent !== THREAD_UNREAD_CSS) found.textContent = THREAD_UNREAD_CSS;
    return;
  }
  const st = doc.createElement('style');
  st.id = STYLE_ID;
  st.textContent = THREAD_UNREAD_CSS;
  doc.head.appendChild(st);
}

function removeCss(doc) {
  try {
    const st = doc && doc.getElementById ? doc.getElementById(STYLE_ID) : null;
    if (st && st.parentNode) st.parentNode.removeChild(st);
  } catch (e) { /* */ }
}

function removeNodes(list) {
  if (!list) return;
  for (let i = 0; i < list.length; i += 1) {
    const el = list[i];
    if (el && el.parentNode) el.parentNode.removeChild(el);
  }
}

function textOf(el) {
  try { return String((el && el.textContent) || '').replace(/\s+/g, ' ').trim(); } catch (e) { return ''; }
}

// footer 가 속한 «가운데 채널 글» 의 루트 id. rhsPost_·searchResult 등 다른 접두면 null.
export function rootIdOf(footer) {
  try {
    const post = footer && typeof footer.closest === 'function' ? footer.closest(POST_SEL) : null;
    const m = post ? ROOT_POST_RE.exec(post.id || '') : null;
    return m ? m[1] : null;
  } catch (e) { return null; }
}

// «답장 N개» 버튼. 클래스가 없으면 footer 안 button 중 글자가 답장/repl 인 첫 번째(우리 배지·지켜보기 제외).
export function replyButtonOf(footer) {
  try {
    const hit = footer.querySelector(REPLY_SEL);
    if (hit) return hit;
    const list = footer.querySelectorAll('button');
    for (let i = 0; i < list.length; i += 1) {
      const b = list[i];
      if (b.classList && b.classList.contains(BADGE_CLASS)) continue;
      if (typeof b.matches === 'function' && b.matches(FOLLOW_SEL)) continue;
      if (REPLY_TEXT_RE.test(b.textContent || '')) return b;
    }
  } catch (e) { /* */ }
  return null;
}

function statusOf(err) {
  try {
    const s = err && err.response ? Number(err.response.status) : Number(err && err.status);
    return Number.isFinite(s) ? s : 0;
  } catch (e) { return 0; }
}

// 서버 한 칸({count, first_unread}) → {count, first}. 숫자가 아니면 null(= 그리지 않는다).
function toValue(c) {
  if (!c || typeof c !== 'object') return null;
  const n = Number(c.count);
  if (!Number.isFinite(n)) return null;
  const first = typeof c.first_unread === 'string' && MM_ID_RE.test(c.first_unread) ? c.first_unread : null;
  return { count: Math.max(0, Math.floor(n)), first };
}

// doc 당 1회 설치. 반환 = dispose(옵저버·타이머 해제 + 배지·점·표식·style 제거). 이미 설치됐거나 doc 이 없으면 null.
// options: isActive() — 거짓이면 조회·읽음은 쉬고 그리기만 · fetchCounts(ids) → Promise<{enabled, counts}>
//          · markRead(rootId) → Promise.
// 🔴 옵저버는 doc.body 에 childList + subtree + characterData — characterData 가 있어야 MM 이 «답장 N개» 글자만
//    고치는 것(WebSocket 갱신)을 잡는다.
export function setupMmThreadUnread(doc, options) {
  const opts = options || {};
  if (!doc || !doc.body || doc.__gwMmThreadUnread) return null;
  const isActive = typeof opts.isActive === 'function' ? opts.isActive : () => true;
  const fetchCounts = typeof opts.fetchCounts === 'function' ? opts.fetchCounts : null;
  const markRead = typeof opts.markRead === 'function' ? opts.markRead : null;
  doc.__gwMmThreadUnread = true;

  let disposed = false;
  let off = false;            // enabled:false · 404 · 동기 예외 — 이 문서가 사는 동안 무동작
  let confirmed = false;      // 서버가 enabled 로 한 번이라도 답했다 — 그 전에는 그리지도 읽지도 않는다
  let timer = null;
  let gapTimer = null;
  let refreshTimer = null;
  let scrollTimer = null;
  let obs = null;
  let inflight = false;
  let lastFetchAt = 0;
  let backoffUntil = 0;
  let refreshAt = 0;
  let openNow = new Set();    // 마지막 점검에서 열린 스레드
  let rhsRoot = null;         // 지금 RHS 에 열린 스레드 — RHS 가 닫히거나 다른 루트가 보일 때까지 유지
  let rhsSize = 0;            // RHS 에 그려진 글 수(답글이 늘었나)
  let intent = null;          // {root, at} — 방금 누른 «답장 N개»·배지·답장 아이콘(MM 이 곧 그 스레드를 연다)
  const cache = new Map();    // root → {count|null, first, at, sig} — 점과 건수는 이 값 하나로 그린다
  const asked = new Set();    // 서버가 한 번이라도 답한 루트
  const reads = new Map();    // 루트 → {open, lastAt, sentAt, rhs, sig, need, busy, timer}

  function activeNow() {
    try { return !!isActive(); } catch (e) { return false; }
  }

  function canRead() {
    return !disposed && !off && !!markRead && confirmed && activeNow();
  }

  function removeAll() {
    try {
      removeNodes(doc.querySelectorAll('.' + BADGE_CLASS));
      removeNodes(doc.querySelectorAll('.' + DOT_CLASS));
      removeNodes(doc.querySelectorAll(INDICATOR_SEL + '.' + WRAP_CLASS));
      const marked = doc.querySelectorAll('[' + MARK_ATTR + ']');
      for (let i = 0; i < marked.length; i += 1) marked[i].removeAttribute(MARK_ATTR);
    } catch (e) { /* */ }
    removeCss(doc);
  }

  function stopTimers() {
    if (timer) { clearTimeout(timer); timer = null; }
    if (gapTimer) { clearTimeout(gapTimer); gapTimer = null; }
    if (refreshTimer) { clearInterval(refreshTimer); refreshTimer = null; }
    if (scrollTimer) { clearTimeout(scrollTimer); scrollTimer = null; }
    reads.forEach((st) => { if (st.timer) { clearTimeout(st.timer); st.timer = null; } });
  }

  function unlisten() {
    try { doc.removeEventListener('click', onDocClick, true); } catch (e) { /* */ }
  }

  // 이 문서 동안 끈다 — MM 원래 모습으로 되돌리고 더는 묻지 않는다(설치 표식은 남겨 재설치도 막는다).
  function disable() {
    if (off) return;
    off = true;
    stopTimers();
    try { if (obs) obs.disconnect(); } catch (e) { /* */ }
    obs = null;
    unlisten();
    removeAll();
    cache.clear();
    reads.clear();
    intent = null;
    rhsRoot = null;
  }

  function clearFooter(footer) {
    try {
      removeNodes(footer.querySelectorAll('.' + BADGE_CLASS));
      removeNodes(footer.querySelectorAll('.' + DOT_CLASS));
      removeNodes(footer.querySelectorAll(INDICATOR_SEL + '.' + WRAP_CLASS));
      if (footer.hasAttribute(MARK_ATTR)) footer.removeAttribute(MARK_ATTR);
    } catch (e) { /* */ }
  }

  function setAttr(el, name, value) {
    if (el.getAttribute(name) !== value) el.setAttribute(name, value);
  }

  // 점 — n > 0 일 때만. MM indicator 가 있으면 그 안, 없으면 footer 첫 자식으로 우리 indicator 를 만든다.
  // MM 이 나중에 자기 indicator 를 그리면 점을 그리로 옮기고 우리 것은 지운다.
  function drawDot(footer, n) {
    const dots = footer.querySelectorAll('.' + DOT_CLASS);
    const wraps = footer.querySelectorAll(INDICATOR_SEL + '.' + WRAP_CLASS);
    if (!(n > 0)) {
      removeNodes(dots);
      removeNodes(wraps);
      return;
    }
    let host = footer.querySelector(INDICATOR_SEL + ':not(.' + WRAP_CLASS + ')');
    if (!host) {
      host = wraps.length ? wraps[0] : null;
      if (!host) {
        host = doc.createElement('span');
        host.className = INDICATOR_SEL.slice(1) + ' ' + WRAP_CLASS;
        host.setAttribute('aria-hidden', 'true');
        footer.insertBefore(host, footer.firstChild);
      }
    }
    let dot = dots.length ? dots[0] : null;
    for (let i = 1; i < dots.length; i += 1) {
      if (dots[i].parentNode) dots[i].parentNode.removeChild(dots[i]);
    }
    if (!dot) {
      dot = doc.createElement('span');
      dot.className = DOT_CLASS + ' dot-unreads';
      dot.setAttribute('aria-hidden', 'true');
    }
    if (dot.parentNode !== host) host.appendChild(dot);
    for (let i = 0; i < wraps.length; i += 1) {
      if (wraps[i] !== host && wraps[i].parentNode) wraps[i].parentNode.removeChild(wraps[i]);
    }
  }

  function scrollToFirst(first) {
    if (scrollTimer) { clearTimeout(scrollTimer); scrollTimer = null; }
    const deadline = Date.now() + SCROLL_WAIT_MS;
    const tick = () => {
      scrollTimer = null;
      if (disposed || off) return;
      let el = null;
      try { el = doc.getElementById(RHS_POST_PREFIX + first); } catch (e) { el = null; }
      if (el) {
        try { if (typeof el.scrollIntoView === 'function') el.scrollIntoView({ block: 'center' }); } catch (e) { /* */ }
        return;
      }
      if (Date.now() >= deadline) return;        // 못 찾으면 아무것도 안 한다
      scrollTimer = setTimeout(tick, SCROLL_STEP_MS);
    };
    tick();
  }

  // 배지 클릭·탭 — MM 이 스레드를 열게 ReplyButton 만 누른다. 🔴 FollowButton 은 건드리지 않는다(지켜보기 불변).
  function onBadgeClick(ev) {
    try { ev.preventDefault(); ev.stopPropagation(); } catch (e) { /* */ }
    if (disposed || off) return;
    try {
      const badge = ev.currentTarget;
      const root = badge.getAttribute('data-root');
      const hit = root ? cache.get(root) : null;
      const first = hit && hit.count > 0 ? hit.first : null;   // 그 순간의 첫 안읽은 답글
      const footer = badge.closest(FOOTER_SEL);
      const reply = footer ? replyButtonOf(footer) : null;
      if (reply && typeof reply.click === 'function') reply.click();
      if (first) scrollToFirst(first);
    } catch (e) { /* MM DOM 변동 — 무동작 */ }
  }

  function drawFooter(footer, reply, root, entry) {
    try {
      const n = entry.count;
      applyCss(doc);                              // 첫 배지 때 들어가고 그 뒤로는 멱등
      if (!footer.hasAttribute(MARK_ATTR)) footer.setAttribute(MARK_ATTR, '1');
      const found = footer.querySelectorAll('.' + BADGE_CLASS);
      let badge = found.length ? found[0] : null;
      for (let i = 1; i < found.length; i += 1) {
        if (found[i].parentNode) found[i].parentNode.removeChild(found[i]);
      }
      if (!badge) {
        badge = doc.createElement('button');
        badge.setAttribute('type', 'button');
        badge.className = BADGE_CLASS;
        badge.addEventListener('click', onBadgeClick);
      }
      if (reply.parentNode && reply.nextSibling !== badge) reply.parentNode.insertBefore(badge, reply.nextSibling);
      const label = formatUnreadLabel(n);
      if (badge.textContent !== label) badge.textContent = label;   // 🔴 textContent 만
      setAttr(badge, 'data-root', root);
      setAttr(badge, 'data-count', String(n));
      setAttr(badge, 'aria-label', label);
      const cls = BADGE_CLASS + ' ' + BADGE_CLASS + (n > 0 ? '--has' : '--zero');
      if (badge.className !== cls) badge.className = cls;
      drawDot(footer, n);
    } catch (e) { /* MM DOM 변동 — 다음 점검에서 다시 */ }
  }

  // RHS 에 그려진 글 id(루트·답글 모두 `rhsPost_<id>` — MM 7+).
  function rhsPostIds() {
    const out = new Set();
    try {
      const list = doc.querySelectorAll('[id^="' + RHS_POST_PREFIX + '"]');
      for (let i = 0; i < list.length; i += 1) {
        const m = RHS_POST_RE.exec(list[i].id || '');
        if (m) out.add(m[1]);
      }
    } catch (e) { /* */ }
    return out;
  }

  // 흔들리지 않는 신호만(부수효과 없음) — 옛 RHS 루트 글 · RHS 에 그려진 «루트로 알려진» 글 · MM 문서 경로
  // /threads/<id>. known = 가운데 footer 의 루트 ∪ 캐시 — 답글 id 는 여기에 들 수 없다(답글엔 footer 가 없다).
  // shown = RHS 에 스레드가 열려 있다(RHS 글 · 스레드 입력창 중 하나라도) — 닫히면 직전 판정을 버린다.
  function detect(known) {
    const rhs = rhsPostIds();
    const strong = new Set();
    let hit = null;
    try {
      const list = doc.querySelectorAll(RHS_ROOT_SEL);
      for (let i = 0; i < list.length; i += 1) {
        const m = RHS_ROOT_RE.exec(list[i].id || '');
        if (m) { strong.add(m[1]); if (!hit) hit = m[1]; }
      }
    } catch (e) { /* */ }
    rhs.forEach((id) => { if (known.has(id)) { strong.add(id); if (!hit) hit = id; } });
    let box = false;
    try { box = !!doc.querySelector(REPLY_BOX_SEL); } catch (e) { box = false; }
    const shown = rhs.size > 0 || strong.size > 0 || box;
    let path = null;
    try {
      const loc = doc.defaultView && doc.defaultView.location;
      const m = THREAD_PATH_RE.exec((loc && loc.pathname) || '');
      if (m) { path = m[1]; strong.add(path); }
    } catch (e) { /* */ }
    return { rhs, strong, hit, shown, path };
  }

  // 열린 스레드(점검마다 1회 — rhsRoot·intent 를 갱신한다).
  // RHS 가 닫혔으면 없음 → 문서 경로 /threads/<id> → 루트 글이 보이면 그 루트 → 방금 누른 루트(INTENT_WAIT_MS 안)
  // → 그 밖엔 직전 판정 유지(긴 스레드에서 루트 글이 스크롤로 가상 목록 밖에 빠져도 RHS 가 이어지는 동안은 같은 스레드다).
  function resolveOpen(known, now) {
    const d = detect(known);
    if (intent && now - intent.at > INTENT_WAIT_MS) intent = null;
    if (!d.shown && !d.path) rhsRoot = null;
    else if (d.path) rhsRoot = d.path;
    else if (d.hit) rhsRoot = d.hit;
    else if (intent) rhsRoot = intent.root;
    rhsSize = d.rhs.size;
    const out = new Set(d.strong);
    if (rhsRoot) out.add(rhsRoot);
    return out;
  }

  // 조회 응답을 받는 순간의 열린 스레드 — 마지막 점검 결과 ∪ 지금 보이는 신호(상태는 바꾸지 않는다).
  function peekOpen(known) {
    const out = new Set(openNow);
    detect(known).strong.forEach((id) => out.add(id));
    return out;
  }

  // 답장 버튼·배지·답장 아이콘 클릭(캡처 단계 — MM 핸들러보다 먼저, 전파는 건드리지 않는다).
  function onDocClick(ev) {
    if (disposed || off) return;
    try {
      const t = ev && ev.target;
      const el = t && t.nodeType === 1 ? t : (t && t.parentElement);
      if (!el || typeof el.closest !== 'function') return;
      let root = null;
      const btn = el.closest('button');
      const footer = btn ? btn.closest(FOOTER_SEL) : null;
      if (footer && (btn.classList.contains(BADGE_CLASS) || btn === replyButtonOf(footer))) root = rootIdOf(footer);
      if (!root) {
        const icon = el.closest('[id^="' + COMMENT_ICON_PREFIX + '"]');
        const id = icon ? String(icon.id || '').slice(COMMENT_ICON_PREFIX.length) : '';
        if (MM_ID_RE.test(id)) root = id;
      }
      if (root) { intent = { root, at: Date.now() }; kick(); }
    } catch (e) { /* MM DOM 변동 — 무동작 */ }
  }

  // 읽음 1건을 보낸다(간격·조건은 부르는 쪽이 본다).
  function fireRead(root, st) {
    st.need = false;
    st.busy = true;
    st.lastAt = Date.now();
    st.sentAt = st.lastAt;
    let p = null;
    try { p = markRead(root); } catch (e) { st.busy = false; st.need = true; return; }
    if (!p || typeof p.then !== 'function') { st.busy = false; return; }
    p.then(
      (res) => { st.busy = false; try { onReadDone(root, st, res); } catch (e) { /* */ } },
      // 없는 루트(404)·비멤버(403)는 다시 보내도 같다 — 그 밖의 실패는 다음 점검에서 다시.
      (err) => { st.busy = false; const s = statusOf(err); if (s !== 403 && s !== 404) st.need = true; },
    ).catch(() => { st.busy = false; });
  }

  function onReadDone(root, st, res) {
    if (disposed || off) return;
    if (res && res.enabled === false) { disable(); return; }
    if (st.need) {                         // 보내는 사이 답글이 또 늘었다
      if (st.open) kick(); else if (canRead()) fireRead(root, st);
      return;
    }
    if (!st.open) {
      // 닫힌 스레드 — 읽음이 기록된 뒤의 값으로 곧 다시 묻는다(그 사이에 받은 «읽음 전» 응답은 무효).
      const hit = cache.get(root);
      if (hit) cache.set(root, { count: hit.count, first: hit.first, at: 0, sig: hit.sig });
      kick();
    }
  }

  function sendRead(root, st) {
    if (!canRead() || st.busy) return;
    const wait = READ_MIN_GAP_MS - (Date.now() - st.lastAt);
    if (wait > 0) {
      if (!st.timer) {
        st.timer = setTimeout(() => { st.timer = null; if (st.open) sendRead(root, st); }, wait);
      }
      return;
    }
    fireRead(root, st);
  }

  function debounceRead(root, st) {
    if (st.timer) clearTimeout(st.timer);
    st.need = true;
    st.timer = setTimeout(() => { st.timer = null; if (st.open) sendRead(root, st); }, READ_DEBOUNCE_MS);
  }

  // 열린 직후 1회, 그 뒤로는 RHS 답글 수나 «답장 N개» 서명이 늘 때마다 디바운스로 읽음을 보낸다.
  // 🔴 닫히는 순간 아직 못 보낸 읽음(디바운스·간격 대기·실패)이 있으면 한 번 보낸다 — 안 그러면 열어 둔 동안 온
  //    답글이 닫은 뒤 +1 로 돌아온다.
  function syncReads(open, sigByRoot, active) {
    reads.forEach((st, root) => {
      if (!st.open || open.has(root)) return;
      st.open = false;
      if (st.timer) { clearTimeout(st.timer); st.timer = null; }
      if (st.need && !st.busy && canRead()) fireRead(root, st);
    });
    open.forEach((root) => {
      const sig = sigByRoot.has(root) ? sigByRoot.get(root) : null;
      let st = reads.get(root);
      if (!st) {
        st = { open: false, lastAt: 0, sentAt: 0, rhs: 0, sig: null, need: false, busy: false, timer: null };
        reads.set(root, st);
      }
      if (!st.open) {                      // 막 열렸다
        st.open = true;
        st.rhs = rhsSize;
        st.sig = sig;
        st.need = true;
      } else {
        const grew = rhsSize > st.rhs || (sig !== null && st.sig !== null && sig !== st.sig);
        st.rhs = rhsSize;
        if (sig !== null) st.sig = sig;
        if (grew) debounceRead(root, st);
      }
      if (active && st.need && !st.timer) sendRead(root, st);
    });
  }

  function applyCounts(batch, sigs, at, data) {
    if (!data || typeof data !== 'object' || data.enabled === false) { disable(); return; }
    confirmed = true;
    const counts = data.counts && typeof data.counts === 'object' ? data.counts : {};
    const known = new Set(cache.keys());
    batch.forEach((root) => known.add(root));
    const open = peekOpen(known);
    batch.forEach((root) => {
      asked.add(root);
      const v = Object.prototype.hasOwnProperty.call(counts, root) ? toValue(counts[root]) : null;
      if (!v) { cache.set(root, { count: null, first: null, at, sig: sigs[root] }); return; }
      let entryAt = at;
      // 열어 둔 스레드는 서버가 > 0 을 줘도 0 — 열어 둔 동안 +1 도 점도 생기지 않는다.
      // 읽음을 보내는 중이거나 이 조회를 시작한 뒤에 보냈으면 서버 값은 «읽음 전» 것이다 — 0 으로 두고,
      // 읽음이 이미 끝났으면 곧 다시 묻는다(at 0).
      const rs = reads.get(root);
      const stale = !!rs && (rs.busy || rs.sentAt >= at);
      if (open.has(root) || stale) {
        v.count = 0;
        v.first = null;
        if (!open.has(root) && !rs.busy) entryAt = 0;
      }
      cache.set(root, { count: v.count, first: v.first, at: entryAt, sig: sigs[root] });
    });
  }

  function failCounts(batch, sigs, at, err) {
    const s = statusOf(err);
    if (s === 404) { disable(); return; }       // API 가 없다(이 조각만 배포됐다) — 활성화도 없다
    if (s === 403) {                            // 그 루트들은 건수를 캐시하지 않는다(MM 점 그대로)
      batch.forEach((root) => {
        asked.add(root);
        cache.set(root, { count: null, first: null, at, sig: sigs[root] });
      });
      return;
    }
    backoffUntil = Date.now() + FAIL_BACKOFF_MS;
  }

  function requestFetch(need, sigByRoot) {
    if (disposed || off || inflight || !fetchCounts) return;
    const now = Date.now();
    if (now < backoffUntil) return;
    const gap = FETCH_MIN_GAP_MS - (now - lastFetchAt);
    if (gap > 0) {
      if (!gapTimer) gapTimer = setTimeout(() => { gapTimer = null; kick(); }, gap);
      return;
    }
    const batch = need.slice(0, MAX_ROOTS);
    const sigs = {};
    batch.forEach((root) => { sigs[root] = sigByRoot.has(root) ? sigByRoot.get(root) : null; });
    inflight = true;
    lastFetchAt = now;
    let p = null;
    try { p = fetchCounts(batch); } catch (e) { p = null; }
    if (!p || typeof p.then !== 'function') { inflight = false; disable(); return; }   // 함수 없음(목) = 무동작
    p.then(
      (data) => { if (!disposed && !off) applyCounts(batch, sigs, now, data); },
      (err) => { if (!disposed && !off) failCounts(batch, sigs, now, err); },
    ).then(() => { inflight = false; kick(); }, () => { inflight = false; });
  }

  function ensureRefresh() {
    if (refreshTimer || disposed || off) return;
    refreshTimer = setInterval(() => {
      if (disposed || off) return;
      refreshAt = Date.now();                     // 이 시각 전에 받은 건수는 전부 다시 묻는다
      try { sync(); } catch (e) { /* */ }
    }, REFRESH_MS);
  }

  function sync() {
    if (disposed || off) return;
    const now = Date.now();
    const active = activeNow();

    let footers = null;
    try { footers = doc.querySelectorAll(FOOTER_SEL); } catch (e) { return; }
    const items = [];
    const known = new Set(cache.keys());
    for (let i = 0; i < footers.length; i += 1) {
      const footer = footers[i];
      const root = rootIdOf(footer);
      const reply = root ? replyButtonOf(footer) : null;
      items.push({ footer, root, reply });
      if (root && reply) known.add(root);
    }

    const open = resolveOpen(known, now);
    openNow = open;
    open.forEach((root) => {
      const hit = cache.get(root);
      if (hit && hit.count !== null && (hit.count !== 0 || hit.first !== null)) {
        cache.set(root, { count: 0, first: null, at: hit.at, sig: hit.sig });
      }
    });

    const need = [];
    const sigByRoot = new Map();
    for (let i = 0; i < items.length; i += 1) {
      const { footer, root, reply } = items[i];
      if (!root || !reply) { clearFooter(footer); continue; }     // 답글 0개·다른 접두 글은 건너뛴다
      const sig = textOf(reply);
      sigByRoot.set(root, sig);
      const hit = cache.get(root);
      // 캐시 없음 · 답장 수 서명이 바뀜(MM WebSocket 갱신) · 20초 경과 → 다시 묻는다.
      if ((!hit || hit.sig !== sig || hit.at < refreshAt || now - hit.at >= REFRESH_MS) && need.indexOf(root) < 0) {
        need.push(root);
      }
      if (confirmed && hit && hit.count !== null) drawFooter(footer, reply, root, hit);
      else clearFooter(footer);
    }
    open.forEach((root) => { if (!asked.has(root) && need.indexOf(root) < 0) need.push(root); });
    if (footers.length || open.size) ensureRefresh();
    if (active && need.length) requestFetch(need, sigByRoot);
    syncReads(open, sigByRoot, active);
  }

  function kick() {
    if (disposed || off || timer) return;   // 쓰로틀 — 메신저 본문은 프레임마다 변이가 난다
    timer = setTimeout(() => {
      timer = null;
      try { sync(); } catch (e) { /* MM DOM 변동 — 무동작 */ }
    }, SYNC_THROTTLE_MS);
  }

  try { sync(); } catch (e) { /* */ }      // 설치 즉시 1회(이미 그려진 글도 잡는다)

  if (!off) {
    try {
      const MO = (doc.defaultView && doc.defaultView.MutationObserver)
        || (typeof window !== 'undefined' ? window.MutationObserver : null);
      if (MO) {
        obs = new MO(kick);
        obs.observe(doc.body, { childList: true, subtree: true, characterData: true });
      }
    } catch (e) { obs = null; }
    try { doc.addEventListener('click', onDocClick, true); } catch (e) { /* */ }
  }

  return function dispose() {
    if (disposed) return;
    disposed = true;                  // 남은 콜백·타이머·비행 중 응답은 여기서부터 무동작
    stopTimers();
    try { if (obs) obs.disconnect(); } catch (e) { /* */ }
    obs = null;
    unlisten();
    removeAll();                      // 배지·우리 점·우리 indicator·표식·style — 설치 흔적 0
    try { doc.__gwMmThreadUnread = false; } catch (e) { /* */ }
  };
}
